type TsSdk = any;

const SCRIPT_ID = 'td-sdk';
const SCRIPT_PATH = '/js/td-sdk.min.js';

export function loadTdSk(): Promise<TsSdk> {
  // Check if we're in a browser environment
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    // Return a resolved promise in SSR context
    return Promise.resolve(true);
  }

  return new Promise((resolve, reject) => {
    const elem = document.getElementById(SCRIPT_ID);

    if (elem !== null) {
      resolve(true);
      return;
    }

    const script = document.createElement('script');
    script.src = SCRIPT_PATH;
    script.id = SCRIPT_ID;
    script.async = true;
    script.onload = () => {
      resolve(true);
    };
    script.onerror = (event) => {
      reject(event);
    };
    document.body.appendChild(script);
  });
}
